import { backendApi } from '@/lib/api/client';

/** Server-reported content hash per table: `{ azure_specialties: "abc…", … }`. */
export async function fetchSyncHashes(): Promise<Record<string, string>> {
  const { data } = await backendApi.get<{ data: Record<string, string> }>(
    '/mobile/azure/sync-hashes',
  );
  return data?.data ?? {};
}

/** Fetch all rows for one nomenclature table. */
export async function fetchTableRows(endpoint: string): Promise<Record<string, unknown>[]> {
  const { data } = await backendApi.get<{ data: Record<string, unknown>[] }>(endpoint);
  return Array.isArray(data?.data) ? data.data : [];
}
